"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = useTimer;

var _react = require("react");

function useTimer(at, fn) {
  (0, _react.useEffect)(function () {
    if (typeof at === 'number') {
      var timeout = setTimeout(fn, Math.max(0, at - Date.now()));
      return function () {
        return clearTimeout(timeout);
      };
    }
  }, [at, fn]);
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6WyJ1c2VUaW1lciIsImF0IiwiZm4iLCJ1c2VFZmZlY3QiLCJ0aW1lb3V0Iiwic2V0VGltZW91dCIsIk1hdGgiLCJtYXgiLCJEYXRlIiwibm93IiwiY2xlYXJUaW1lb3V0Il0sInNvdXJjZVJvb3QiOiJjb21wb25lbnQ6Ly8vIiwic291cmNlcyI6WyIuLi8uLi8uLi9zcmMvaG9va3MvaW50ZXJuYWwvdXNlVGltZXIuanMiXSwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHsgdXNlRWZmZWN0IH0gZnJvbSAncmVhY3QnO1xuXG5leHBvcnQgZGVmYXVsdCBmdW5jdGlvbiB1c2VUaW1lcihhdCwgZm4pIHtcbiAgdXNlRWZmZWN0KCgpID0+IHtcbiAgICBpZiAodHlwZW9mIGF0ID09PSAnbnVtYmVyJykge1xuICAgICAgY29uc3QgdGltZW91dCA9IHNldFRpbWVvdXQoZm4sIE1hdGgubWF4KDAsIGF0IC0gRGF0ZS5ub3coKSkpO1xuXG4gICAgICByZXR1cm4gKCkgPT4gY2xlYXJUaW1lb3V0KHRpbWVvdXQpO1xuICAgIH1cbiAgfSwgW2F0LCBmbl0pO1xufVxuIl0sIm1hcHBpbmdzIjoiOzs7Ozs7O0FBQUE7O0FBRWUsU0FBU0EsUUFBVCxDQUFrQkMsRUFBbEIsRUFBc0JDLEVBQXRCLEVBQTBCO0VBQ3ZDLElBQUFDLGdCQUFBLEVBQVUsWUFBTTtJQUNkLElBQUksT0FBT0YsRUFBUCxLQUFjLFFBQWxCLEVBQTRCO01BQzFCLElBQU1HLE9BQU8sR0FBR0MsVUFBVSxDQUFDSCxFQUFELEVBQUtJLElBQUksQ0FBQ0MsR0FBTCxDQUFTLENBQVQsRUFBWU4sRUFBRSxHQUFHTyxJQUFJLENBQUNDLEdBQUwsRUFBakIsQ0FBTCxDQUExQjtNQUVBLE9BQU87UUFBQSxPQUFNQyxZQUFZLENBQUNOLE9BQUQsQ0FBbEI7TUFBQSxDQUFQO0lBQ0Q7RUFDRixDQU5ELEVBTUcsQ0FBQ0gsRUFBRCxFQUFLQyxFQUFMLENBTkg7QUFPRCJ9